document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initComparador();
  initGaleriaProducto();
  initVariantes();
  initCantidad();
  initFaq();
});

/* Revela elementos .mt-reveal al entrar en pantalla */
function initReveal() {
  var elementos = document.querySelectorAll('.mt-reveal');
  if (!elementos.length) return;

  if (!('IntersectionObserver' in window)) {
    elementos.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  elementos.forEach(function (el) { observer.observe(el); });
}

/* Comparador antes / después con deslizador */
function initComparador() {
  document.querySelectorAll('[data-mt-comparador]').forEach(function (wrap) {
    var despues = wrap.querySelector('.mt-comparador__despues');
    var handle = wrap.querySelector('.mt-comparador__handle');
    if (!despues || !handle) return;

    var activo = false;

    function mover(clientX) {
      var rect = wrap.getBoundingClientRect();
      var x = clientX - rect.left;
      var pct = Math.min(100, Math.max(0, (x / rect.width) * 100));
      despues.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
    }

    wrap.addEventListener('pointerdown', function (e) {
      activo = true;
      mover(e.clientX);
    });
    window.addEventListener('pointermove', function (e) {
      if (!activo) return;
      mover(e.clientX);
    });
    window.addEventListener('pointerup', function () { activo = false; });

    wrap.addEventListener('touchstart', function (e) {
      mover(e.touches[0].clientX);
    }, { passive: true });
    wrap.addEventListener('touchmove', function (e) {
      mover(e.touches[0].clientX);
    }, { passive: true });
  });
}

/* Galería de la página de producto: cambia la imagen principal */
function initGaleriaProducto() {
  var principal = document.querySelector('[data-mt-galeria-principal]');
  if (!principal) return;

  document.querySelectorAll('[data-mt-miniatura]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var full = btn.getAttribute('data-full');
      var alt = btn.getAttribute('data-alt') || '';
      if (!full) return;
      principal.src = full;
      principal.alt = alt;
      document.querySelectorAll('[data-mt-miniatura]').forEach(function (b) { b.classList.remove('mt-activa'); });
      btn.classList.add('mt-activa');
    });
  });
}

/* Selector de variantes: actualiza id oculto, precio y disponibilidad */
function initVariantes() {
  var form = document.querySelector('[data-mt-producto-form]');
  if (!form) return;

  if (!document.querySelector('[data-mt-opcion]')) return;

  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;

  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var inputId = form.querySelector('input[name="id"]');
  var botonSubmit = form.querySelector('[data-mt-submit]');
  var precioActual = document.querySelector('[data-mt-precio-actual]');
  var precioAnterior = document.querySelector('[data-mt-precio-anterior]');
  var stockAviso = document.querySelector('[data-mt-stock]');

  function formatoDinero(cantidad) {
    return Number(cantidad).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR',
    });
  }

  function opcionesSeleccionadas() {
    var seleccion = [];
    document.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
      var activa = grupo.querySelector('.mt-activa');
      seleccion.push(activa ? activa.getAttribute('data-valor') : null);
    });
    return seleccion;
  }

  function encontrarVariante() {
    var seleccion = opcionesSeleccionadas();
    return variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
  }

  function actualizar() {
    var variante = encontrarVariante();
    if (!variante) {
      if (botonSubmit) { botonSubmit.disabled = true; botonSubmit.textContent = botonSubmit.getAttribute('data-texto-agotado') || 'No disponible'; }
      return;
    }
    if (inputId) inputId.value = variante.id;
    if (precioActual) precioActual.textContent = formatoDinero(variante.price);
    if (precioAnterior) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioAnterior.textContent = formatoDinero(variante.compare_at_price);
        precioAnterior.style.display = '';
      } else {
        precioAnterior.style.display = 'none';
      }
    }
    if (botonSubmit) {
      if (variante.available) {
        botonSubmit.disabled = false;
        botonSubmit.textContent = botonSubmit.getAttribute('data-texto-normal') || 'Añadir al carrito';
      } else {
        botonSubmit.disabled = true;
        botonSubmit.textContent = botonSubmit.getAttribute('data-texto-agotado') || 'Agotado';
      }
    }
    if (stockAviso) stockAviso.style.display = variante.available ? '' : 'none';

    document.querySelectorAll('[data-mt-opcion]').forEach(function (grupo, i) {
      grupo.querySelectorAll('[data-mt-pill]').forEach(function (pill) {
        var valor = pill.getAttribute('data-valor');
        var prueba = opcionesSeleccionadas();
        prueba[i] = valor;
        var existe = variantes.some(function (v) {
          return v.options.every(function (opt, idx) { return opt === prueba[idx]; });
        });
        pill.disabled = !existe;
      });
    });
  }

  document.querySelectorAll('[data-mt-pill]').forEach(function (pill) {
    pill.addEventListener('click', function () {
      if (pill.disabled) return;
      var grupo = pill.closest('[data-mt-opcion]');
      grupo.querySelectorAll('[data-mt-pill]').forEach(function (p) { p.classList.remove('mt-activa'); });
      pill.classList.add('mt-activa');
      actualizar();
    });
  });

  actualizar();
}

/* Selector de cantidad +/- */
function initCantidad() {
  document.querySelectorAll('[data-mt-cantidad]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var menos = wrap.querySelector('[data-mt-menos]');
    var mas = wrap.querySelector('[data-mt-mas]');
    if (!input) return;
    if (menos) menos.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
    });
    if (mas) mas.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
    });
  });
}

/* FAQ desplegable */
function initFaq() {
  document.querySelectorAll('.mt-faq__item').forEach(function (item) {
    var pregunta = item.querySelector('.mt-faq__pregunta');
    var respuesta = item.querySelector('.mt-faq__respuesta');
    if (!pregunta || !respuesta) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-abierto');
      document.querySelectorAll('.mt-faq__item.mt-abierto').forEach(function (otro) {
        otro.classList.remove('mt-abierto');
        otro.querySelector('.mt-faq__respuesta').style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('mt-abierto');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}
